<template>
  <div v-if="cookieSearchPrevious" class="m-search-previous">
    <div class="container">
      <h2 class="m-search-previous__headline">
        {{ $t('SearchPrevious', 'Tidligere søgninger') }}
      </h2>
      <div class="row">
        <div
          v-for="(prevQuery, i) in cookieSearchPrevious"
          :key="i"
          class="mb-4"
          :class="cookieSearchPrevious && cookieSearchPrevious.length <= 2 ? 'col-3' : 'col'"
        >
          <base-button
            class="m-search-previous__button"
            @click="setQueryParam(prevQuery)"
          >
            {{ prevQuery }}
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/atoms/BaseButton';
export default {
  name: 'SearchPrevious',
  components: {
    BaseButton
  },
  data () {
    return {
      cookieSearchPrevious: '',
      separator: '|',
      query: this.$route.query?.query
    }
  },
  created () {
    this.cookieSearchPrevious = this.$cookies.get('searchPrevious')?.split(this.separator);
    this.setPreviousSearch(this.cookieSearchPrevious);
  },
  methods: {
    setPreviousSearch (arrSearchPrevious) {
      // Remove separator from string in case the user used the symbol
      let query = this.query?.replace(this.separator, '').trim();
      if (!query || !query.length) return;
      if (arrSearchPrevious) {
        // Don't do anything if the array already contains the query string
        if (!arrSearchPrevious.includes(query)) {
          // Only keep latest 5 search quries
          if (arrSearchPrevious && arrSearchPrevious.length >= 5) arrSearchPrevious.pop();
          // Merge quries into a list
          let searchPrevious = [query, ...arrSearchPrevious];
          this.setCookie(searchPrevious.join(this.separator));
          this.cookieSearchPrevious = searchPrevious;
        }
      } else {
        this.setCookie(query);
        this.cookieSearchPrevious = [ query ];
      }
    },
    setCookie (string) {
      this.$cookies.set('searchPrevious', string, {
        path: '/',
        maxAge: 60 * 60 * 24 * 200
      });
    },
    setQueryParam (queryString) {
      this.$router.push({
        path: window.location.pathname,
        query: {
          query: queryString
        }
      })
    }
  }
}
</script>